import * as React from 'react';
import {HTMLAttributes} from 'react';
import cx from 'classnames';

export const Table: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cx(
        'table h-full w-full',
        'border border-[#d5dadd] rounded-[3px] border-separate',
        className,
      )}
    >
      {children}
    </div>
  );
};

export const Thead: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className={cx('table-header-group', className)} {...props}>
      {children}
    </div>
  );
};

export const Tr: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className={cx('table-row', className)} {...props}>
      {children}
    </div>
  );
};

export const Th: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={cx(
        'table-cell p-[10px] bg-[#eff0f0]',
        'border-b border-b-[#d4d9dc] border-l-[#d5dadd]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const Td: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={cx('table-cell p-[10px]', 'border-l-[#d5dadd]', className)}
      {...props}
    >
      {children}
    </div>
  );
};

export const TBodyRow: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={cx(
        'table-row border-b border-b-[#d4d9dc] last:border-b-0  hover:bg-[#f1f1f2] hover:bg-opacity-[0.9]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const Tbody: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className={cx('table-row-group', className)} {...props}>
      {children}
    </div>
  );
};

export const CenterCell: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        'relative top-1/2 -translate-y-1/2 text-center',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
